import React from 'react'
import { Modal, Button, Input } from 'react-bootstrap'
import VInput from './input'
import ReactMixin from 'react-mixin'
import ImmutableRenderMixin from 'react-immutable-render-mixin'
import createLinkToImmutable from '_/utils/createLinkToImmutable'
import { Map } from 'immutable'

@ReactMixin.decorate(ImmutableRenderMixin)
class AddPhotoModal extends React.Component {
  static propTypes = {
    show: React.PropTypes.bool,
    property: React.PropTypes.object.isRequired,
    onChange: React.PropTypes.func.isRequired,
    onHide: React.PropTypes.func.isRequired
  }
  static contextTypes = {
    store: React.PropTypes.object,
    router: React.PropTypes.func
  }

  constructor(props, context) {
    super(props, context)
    this.state = {
      photo: Map(),
      link: createLinkToImmutable(this, 'photo')
    }
  }

  async uploadPhoto (evt) {
    evt.preventDefault()
    const { property, onChange } = this.props
    const { photo } = this.state
    const { store } = this.context
    const file = this.refs.file.getInputDOMNode().files[0]

    this.setState({ disableSubmit: true })

    try {
      const newPhoto = await store.post(`/properties/${property.get('id')}/photos`, photo)
      await store.put(`/properties/${property.get('id')}/photos/${newPhoto.get('id')}`, file)
      onChange(newPhoto)
    } catch (er) {
      this.setState({
        errors: er.response.body.details
      })
    }

    this.setState({ disableSubmit: false })
  }

  render() {
    const { show, onHide } = this.props
    const { link, disableSubmit } = this.state

    return (
      <Modal show={show} onHide={onHide}>
        <Modal.Header closeButton>
          <h3 className="modal-title">Upload new photo</h3>
        </Modal.Header>
        <Modal.Body>
          <VInput
            autoFocus
            type="textarea"
            label="Description of photo"
            valueLink={link('description')}
            name="description" />
          <Input
            ref="file"
            type="file"
            name="photo"
            label="Photo file"
            help="Upload a high quality image (or single-page pdf) for this property to be used to identify the property." />
        </Modal.Body>
        <Modal.Footer>
          <Button
            type="submit"
            disabled={disableSubmit}
            bsStyle="primary"
            onClick={::this.uploadPhoto}>
            Upload photo
          </Button>
        </Modal.Footer>
      </Modal>
    )
  }
}

export default AddPhotoModal



// WEBPACK FOOTER //
// ./modules/shared/components/addPhotoModal.js